import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { resizeAndUploadImage } from '@/shared/utils/imageUploadUtility'
import { useAlertService } from '@/shared/lib/useAlertService'
import {
    getFromLocalStorage,
    deleteFromLocalStorage
} from '@/shared/utils/localStorageHelper'
import { AuthService } from '@/shared/api/rest/services/auth.service'

export function useSignupHandler() {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const navigate = useNavigate()
    const alertService = useAlertService()

    const onSubmit = async (formValue: any, reset: () => void) => {
        setIsSubmitting(true)

        try {
            // The image upload must stay inside the try. It used to run before
            // this block, so a Cloudinary rejection escaped before `finally`
            // could reset isSubmitting — leaving the button stuck on
            // "Submitting" with no error shown.
            const imageUrl = getFromLocalStorage('image-url')
            const hasImageBeenUploaded = await resizeAndUploadImage(formValue, imageUrl)

            const signupData = {
                firstName: formValue.firstName,
                lastName: formValue.lastName,
                email: formValue.email,
                password: formValue.password,
                phoneNumber: formValue.phoneNumber,
                relationship: formValue.relationship,
                role: formValue.role ?? 'parent',
                branch: formValue.branch.value,
                picture: hasImageBeenUploaded || formValue.picture
            }

            await AuthService.signup(signupData)

            deleteFromLocalStorage('image-url')
            reset()

            alertService.success(
                'Account created successfully! Please login to continue.'
            )
            navigate('/')
        } catch (error: any) {
            const errorMessage =
                error instanceof Error ? error.message : 'An unexpected error occurred'
            alertService.error(errorMessage)
        } finally {
            setIsSubmitting(false)
            deleteFromLocalStorage('image-url')
        }
    }

    return { onSubmit, isSubmitting }
}
